import script from "./auditlocus.vue?vue&type=script&lang=ts&setup=true"
export * from "./auditlocus.vue?vue&type=script&lang=ts&setup=true"

import "./auditlocus.vue?vue&type=style&index=0&id=042719c7&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042719c7"]])

export default __exports__